import { useMemo } from 'react';

import type { RhinoImageRatio } from '../..';
import { useCategoryTreeItem } from '../categoryTree';
import { KuxFilteredCategoriesDTO, tvpil } from '../compat/tvpil';

import { getChannelIconSettings } from './utils/getChannelIconSettings';

type UseZapperSettingsProps = {
  referenceId: string;
};

export type ZapperSettings = {
  branding: KuxFilteredCategoriesDTO['uiDesignElements'];
  channelIconRatio: RhinoImageRatio;
  channelIconType: number | undefined;
  imageRatio: RhinoImageRatio;
  imageType: number | undefined;
  maxEpgDaysBackward: number;
  maxEpgDaysForward: number;
  visibilityDuration: number;
};

export function useZapperSettings({ referenceId }: UseZapperSettingsProps): ZapperSettings | undefined {
  const category = useCategoryTreeItem(referenceId);

  return useMemo(() => {
    if (!category) {
      return;
    }

    const imageType = category.epgProperty.assetPresentationImageType;
    const presentationRatio = category.epgProperty.presentationRatio;

    const imageRatio = tvpil.imageTypes.find((type) => type.id === imageType)?.ratio ?? presentationRatio;

    const channelIconSettings = getChannelIconSettings(category.railImageProperty.channelPresentationImageType);

    return {
      branding: category.uiDesignElements,
      channelIconRatio: channelIconSettings.channelIconRatio,
      channelIconType: channelIconSettings.channelIconType,
      imageRatio,
      imageType,
      maxEpgDaysBackward: category.epgProperty.maxEpgDateBackward,
      maxEpgDaysForward: category.epgProperty.maxEpgDateForward,
      visibilityDuration: category.epgProperty.zapperShowDurationInSeconds * 1000,
    };
  }, [category]);
}
